<template>
  <div class="result-wrap">
    <div class="result-content">
      <img
        v-if="$route.query.isSuccess && $route.query.isSuccess === '1'"
        class="result-icon success"
        :class="{ 'animate__animated animate__bounce': !showReward }"
        src="@/assets/img/sdws/success-result.png"
        alt=""
      />
      <img
        v-else
        class="result-icon fail animate__animated  animate__swing"
        src="@/assets/img/sdws/fail-result.png"
        alt=""
      />
      <template v-if="$route.query.isSuccess && $route.query.isSuccess === '1'">
        <h2 class="result-text success-text animate__animated animate__pulse">
          恭喜您
        </h2>
        <p class="success-tips">通关成功!</p>
        <p class="result-more">
          <span>本次通关用时 {{ resInfo?.longTime }}</span>
          <span>排名第 {{ resInfo?.rowNum }} 名</span>
        </p>
        <p class="result-tips fail-tips">
          今日还有
          <strong class="animate__animated animate__slideInDown count-text">
            {{
              $store.getters.getAnswerCount?.leftTimes >= 0
                ? $store.getters.getAnswerCount?.leftTimes
                : 0
            }}
          </strong>
          次答题机会
        </p>
      </template>
      <template v-else>
        <h2 class="result-text fail-text">通关失败，再接再厉吧！</h2>
        <p class="result-tips fail-tips">
          今日还有
          <strong class="animate__animated animate__slideInDown count-text">
            {{
              $store.getters.getAnswerCount?.leftTimes >= 0
                ? $store.getters.getAnswerCount?.leftTimes
                : 0
            }}
          </strong>
          次答题机会
        </p>
      </template>
      <div
        class="record-wrap"
        :class="{ 'fail-record': $route.query.isSuccess === '0' }"
      >
        <span>
          {{
            resInfo?.fastTime
              ? `我的最快用时${formatDuring(resInfo?.fastTime)}`
              : '暂未通关'
          }}
        </span>
        <span
          >{{ resInfo?.rowNum ? `暂排${resInfo?.rowNum}名` : '暂无排名' }}
        </span>
      </div>
      <!-- 按钮 -->
      <div class="btn-wrap">
        <Button @click="handleJump2Home" class="btn">返回首页</Button>
        <Button @click="handleJump2Home(event, 'again')" class="btn"
          >再次闯关</Button
        >
        <Button @click="handleShareClick" class="btn">邀请好友答题</Button>
        <Button @click="showPoster = true" class="btn">分享战绩</Button>
      </div>
      <div class="connect-tips">
        <p>
          如有问题，请发送至齐鲁文化大会官方邮箱账号：qiluwenhuadahui@163.com
        </p>
      </div>
    </div>
  </div>
  <!-- 遮罩 -->
  <div class="mask"></div>
  <!-- 海报 -->
  <Overlay :show="showPoster" @click="showPoster = false">
    <Poster :resInfo="resInfo" />
  </Overlay>
  <!-- 分享好友提示 -->
  <Overlay :show="showShareTips" @click="showShareTips = false">
    <img
      class="share-tips animate__animated animate__fadeInUp"
      src="@/assets/img/sdws/share-tips.png"
      alt=""
    />
  </Overlay>
  <!-- 通过成功选奖品 -->
  <Overlay :show="showReward" :lock-scroll="false">
    <ChooseReward @close="showReward = false" />
  </Overlay>
  <!-- 分享按钮 -->
  <Overlay :show="showShareBtnTips">
    <ShareTips @close="showShareBtnTips = false" />
  </Overlay>
</template>

<script>
import { reactive, ref, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { Overlay, Button } from 'vant'
import qs from 'qs'
import { getResult } from '@/api/index'
import Poster from './components/poster.vue'
import ChooseReward from './components/chooseReward.vue'
import ShareTips from './components/shareTips'
import { formatDuring } from '@/utils/tools'
import { getCountByShare } from '@/api/sdws'
import { useCommonAnswerCountEffect } from '@/effects/sdwsEffect.js'

export default {
  components: {
    Poster,
    Overlay,
    Button,
    ChooseReward,
    ShareTips
  },
  setup() {
    const route = useRoute()
    const router = useRouter()

    if (window.wx) {
      window.wx.showAllNonBaseMenuItem()
    }

    // 选择奖品
    const { showReward } = useRewardEffect()

    // 监听回答次数
    const { showShareBtnTips } = useSubmitCountEffect(showReward)

    // 分享后获得次数接口
    const { fetchCountData } = useCommonAnswerCountEffect()

    // 回答结果
    const { resInfo } = resultInfoEffect()

    const handleJump2Home = (e, isAgain) => {
      const query = {
        questionActiveKey: route.query.questionActiveKey
      }
      if (isAgain) {
        query.isAgain = true
      }
      router.replace({
        path: '/custom/sdws/home',
        query
      })
    }

    // 海报
    const { showPoster } = usePosterEffect()

    // 分享提示
    const { showShareTips } = useShareTipsEffect()

    const { handleShareClick } = useShareEffect(showShareTips, fetchCountData)

    return {
      resInfo,
      handleJump2Home,
      showPoster,
      showShareTips,
      showShareBtnTips,
      showReward,
      formatDuring,
      handleShareClick
    }
  }
}

// 回答次数到零处置
const useSubmitCountEffect = showReward => {
  const store = useStore()
  const showShareBtnTips = ref(false)

  watchEffect(() => {
    if (
      store.getters.getAnswerCount?.shareFlag &&
      store.getters.getAnswerCount?.leftTimes <= 0 &&
      !showReward.value
    ) {
      showShareBtnTips.value = true
    }
  })

  return {
    showShareBtnTips
  }
}

// 分享获得答题次数
const useShareEffect = (showShareTips, fetchCountData) => {
  const route = useRoute()
  const store = useStore()
  const getShareCount = async () => {
    const res = await getCountByShare({
      questionActiveKey: route.query.questionActiveKey,
      token: store.getters.getToken
    })

    if (res.ok) {
      fetchCountData()
    }
  }

  const handleShareClick = () => {
    showShareTips.value = true
    if (window.wx) {
      window.wx.onMenuShareAppMessage({
        title: store.getters.getShareInfo?.shareTitle || document.title,
        desc: store.getters.getShareInfo?.shareDesc,
        imgUrl: store.getters.getShareInfo?.shareIcon,
        link: `https://qlwhdh.iqilu.com/h5/#/custom/sdws/?questionActiveKey=${route.query.questionActiveKey}`,
        success: function() {
          showShareTips.value = false
          getShareCount()
        }
      })
    }
  }

  return {
    handleShareClick
  }
}

// 获取考试结果
const resultInfoEffect = () => {
  const resInfo = reactive({
    score: undefined,
    rank: undefined,
    rightCount: 0,
    lotteryUrl: '',
    rowNum: 0,
    total: 0,
    totalCount: 0
  })
  const route = useRoute()
  const store = useStore()

  const getResultInfo = async () => {
    const res = await getResult(
      qs.stringify({
        questionActiveKey: route.query.questionActiveKey,
        type: 1, // 正式考试
        token: store.getters.getToken,
        answerGroupKey: route.query.answerGroupKey
      })
    )
    resInfo.score = res.data.score
    resInfo.longTime = formatDuring(res.data.longTime)
    resInfo.rank = res.data.rank
    resInfo.fastTime = res.data.fastTime
    resInfo.rightCount = res.data.rightCount
    resInfo.rowNum = res.data.rowNum
    resInfo.total = res.data.total
    resInfo.totalCount = res.data.totalCount
    resInfo.lotteryUrl = res.data.lotteryUrlNew || res.data.lotteryUrl
  }

  getResultInfo()

  return {
    resInfo,
    getResultInfo
  }
}

// 海报
const usePosterEffect = () => {
  const showPoster = ref(false)

  return { showPoster }
}

// 选择奖品
const useRewardEffect = () => {
  const showReward = ref(false)
  const route = useRoute()

  const isSuccess = parseInt(route.query.isSuccess)

  if (isSuccess === 1) {
    showReward.value = true
  }

  return {
    showReward
  }
}

// 分享按钮
const useShareTipsEffect = () => {
  const showShareTips = ref(false)

  if (window.wx) {
    window.wx.onMenuShareAppMessage({
      success: function() {
        showShareTips.value = false
      }
    })
  }

  return {
    showShareTips
  }
}
</script>
<style lang="scss" scoped>
.result-wrap {
  margin: 0 auto;
  width: 100%;
  max-width: 750px;
  min-height: 100vh;
  background: url('../../../assets/img/sdws/content-bg.png');
  background-size: 100% 100%;

  .result-content {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 690px;
    height: 1004px;
    background: url('../../../assets/img/sdws/result-content.png');
    background-size: 100% 100%;
    z-index: 1;

    .result-icon {
      display: block;
      margin: 0 auto;
      width: 288px;
      height: 244px;
    }

    img.fail {
      width: 234px;
      height: 198px;
      padding-top: 206px;
    }

    img.success {
      padding-top: 130px;
    }

    .result-text {
      text-align: center;
      font-size: 48px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #b8352c;
    }
    .result-tips {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      text-align: center;
      font-size: 36px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #aa6e29;

      strong {
        margin: 0 12px;
        font-size: 64px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #ba372c;
        min-width: 80px;
      }
    }

    .success-tips {
      margin-top: 10px;
      text-align: center;
      font-size: 40px;
      color: #8b5e2f;
      font-weight: bold;
    }

    .result-more {
      margin-top: 40px;
      text-align: center;
      font-size: 28px;
      font-family: FZLTHK--GBK1-0, FZLTHK--GBK1;
      font-weight: normal;
      color: #8b5e2f;
      line-height: 34px;

      span {
        &:last-child {
          margin-left: 86px;
        }
      }
    }

    .success-text {
      margin-top: 28px;
    }

    .fail-text {
      margin-top: 44px;
    }

    .record-wrap {
      display: flex;
      justify-content: space-between;
      margin: 0 30px;
      margin-top: 90px;
      font-size: 28px;
      font-family: FZLTHK--GBK1-0, FZLTHK--GBK1;
      font-weight: normal;
      color: #8b5e2f;
    }

    .fail-record {
      margin-top: 180px;
    }

    .btn-wrap {
      text-align: center;
      margin-top: 38px;

      .btn {
        // margin-bottom: 20px;
        padding: 0;
        width: 234px;
        height: 64px;
        font-size: 32px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #fff2c3;
        background: #2c788e;
        border-radius: 8px;
        border: 3px solid #ffd7b8;

        &:nth-child(2n) {
          margin-left: 30px;
        }
      }
    }

    .connect-tips {
      position: absolute;
      bottom: -120px;
      text-align: center;
      font-size: 28px;
      color: #ccc;
    }
  }
}

.share-tips {
  position: absolute;
  top: 0;
  right: 62px;
  width: 520px;
  height: 380px;
  z-index: 2;
}

.mask {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba($color: #000000, $alpha: 0.4);
}
</style>
